var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 5.99943H16V4.32943C15.9765 3.68924 15.7002 3.08448 15.2316 2.64772C14.7629 2.21095 14.1402 1.97782 13.5 1.99943H10.5C9.85975 1.97782 9.23706 2.21095 8.76843 2.64772C8.2998 3.08448 8.02346 3.68924 8 4.32943V5.99943H3C2.73478 5.99943 2.48043 6.10478 2.29289 6.29232C2.10536 6.47986 2 6.73421 2 6.99943C2 7.26464 2.10536 7.519 2.29289 7.70653C2.48043 7.89407 2.73478 7.99943 3 7.99943H4V18.9994C4 19.7951 4.31607 20.5581 4.87868 21.1207C5.44129 21.6834 6.20435 21.9994 7 21.9994H17C17.7956 21.9994 18.5587 21.6834 19.1213 21.1207C19.6839 20.5581 20 19.7951 20 18.9994V7.99943H21C21.2652 7.99943 21.5196 7.89407 21.7071 7.70653C21.8946 7.519 22 7.26464 22 6.99943C22 6.73421 21.8946 6.47986 21.7071 6.29232C21.5196 6.10478 21.2652 5.99943 21 5.99943ZM10 4.32943C10 4.16943 10.21 3.99943 10.5 3.99943H13.5C13.79 3.99943 14 4.16943 14 4.32943V5.99943H10V4.32943ZM18 18.9994C18 19.2646 17.8946 19.519 17.7071 19.7065C17.5196 19.8941 17.2652 19.9994 17 19.9994H7C6.73478 19.9994 6.48043 19.8941 6.29289 19.7065C6.10536 19.519 6 19.2646 6 18.9994V7.99943H18V18.9994Z",
    fill: "#1B1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 17C9.26522 17 9.51957 16.8946 9.70711 16.7071C9.89464 16.5196 10 16.2652 10 16V12C10 11.7348 9.89464 11.4804 9.70711 11.2929C9.51957 11.1054 9.26522 11 9 11C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12V16C8 16.2652 8.10536 16.5196 8.29289 16.7071C8.48043 16.8946 8.73478 17 9 17Z",
    fill: "#1B1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 17C15.2652 17 15.5196 16.8946 15.7071 16.7071C15.8946 16.5196 16 16.2652 16 16V12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12V16C14 16.2652 14.1054 16.5196 14.2929 16.7071C14.4804 16.8946 14.7348 17 15 17Z",
    fill: "#1B1C1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductDelete);
export default __webpack_public_path__ + "static/media/icon_product_delete.f45bc0b74538580032e7ebf22015b5e8.svg";
export { ForwardRef as ReactComponent };